import React from 'react';
import StateSocialWorkerJobsPage from './StateSocialWorkerJobsPage';

const NevadaSocialWorkerJobs = () => {
  return (
    <StateSocialWorkerJobsPage
      stateName="Nevada"
      stateAbbr="NV"
      metaTitle="Nevada Social Worker Jobs (LMSW, LCSW, MSW) | INeedASocialWorker"
      metaDescription="Find Nevada social worker jobs in hospitals, hospice, schools, behavioral health, and community agencies. Search Las Vegas, Reno, Henderson jobs. Apply fast."
      cities={[
        "Las Vegas",
        "Reno",
        "Henderson",
        "North Las Vegas",
        "Sparks",
        "Carson City",
        "Elko",
        "Boulder City",
        "Mesquite",
        "Fernley"
      ]}
      stateDescription="Looking for social work jobs in Nevada? The Silver State offers growing opportunities in healthcare, behavioral health, and community services, especially in the Las Vegas and Reno metropolitan areas."
      faqItems={[
        {
          question: "What types of social work jobs are hiring in Nevada right now?",
          answer: "Nevada employers commonly hire for hospital/medical social work, behavioral health, substance abuse treatment, school-based services, and community mental health. Las Vegas has the highest concentration of positions."
        },
        {
          question: "What license do I need to practice social work in Nevada?",
          answer: "Nevada requires the LCSW (Licensed Clinical Social Worker) for clinical practice and the LSW (Licensed Social Worker) or LISW for MSW graduates without clinical licensure. Nevada recognizes out-of-state licenses through reciprocity agreements."
        },
        {
          question: "What is the average salary for social workers in Nevada?",
          answer: "Nevada social workers typically earn $50,000-$75,000+ depending on setting, experience, and location. Las Vegas and Reno offer competitive salaries, and Nevada has no state income tax, increasing take-home pay."
        },
        {
          question: "How do I apply faster?",
          answer: "Create your profile, upload your resume, and use one-click apply when available through our SW Express Apply™ feature."
        }
      ]}
    />
  );
};

export default NevadaSocialWorkerJobs;
